import EntityType from '@enums/EntityType';
import isEntityProperty from '@utils/properties/isEntityProperty';
import isEntitySkill from '@utils/skills/isEntitySkill';
import isTag from '@utils/tags/isTag';

export default function isLibraryEntity(entityType) {
  if (isTag(entityType)) {
    return true;
  }
  if (isEntitySkill(entityType)) {
    return true;
  }
  if (isEntityProperty(entityType)) {
    return true;
  }
  if (entityType === EntityType.PERSON) {
    return true;
  }

  if (entityType === EntityType.ACTIVITY_TYPE) {
    return true;
  }

  if (entityType === EntityType.ROLE_TYPE) {
    return true;
  }
}
